/**
* All rights Reserved, Designed By www.feidai.com
* @Title: ccx.ts
* @Package: 常常鲜
* @author: 飞贷金融科技
* @date: 2024/12/05 15:41:15
* @version: V1.0
* @Copyright: 2019 www.feidai.com Inc. All rights reserved.
* @Belong To: 飞贷金融科技
* 注意：本内容仅限于深圳中兴飞贷金融科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
*/
import { axiosAPIUrl, Parameter } from '@/api/index'

// 5.1.1 CCX001-申请开通店铺 openStore
export function openStore (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjStore/CCX/store/openStore',
    method: 'post',
    data: parameter,
  })
}

// 5.1.2 CCX002-是否开通店铺 isOpenStore
export function isOpenStore (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjStore/CCX/store/isOpenStore',
    method: 'get',
    params: parameter
  })
}

// 5.1.3 CCX003-修改店铺信息 updateStore
export function updateStore (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjStore/CCX/store/updateStore',
    method: 'post',
    data: parameter,
  })
}

// 5.1.4 CCX004-获取店铺详情 getStoreInfo
export function getStoreInfo (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjStore/CCX/store/getStoreInfo',
    method: 'get',
    params: parameter
  })
}

// 5.1.5 CCX005-店铺查询绑定的供应商列表getSupplierList
export function getSupplierList (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjStore/CCX/store/getSupplierList',
    method: 'get',
    params: parameter
  })
}

// 5.1.6 CCX006-绑定新供应商 bindingNewSupplier
export function bindingNewSupplier (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjStore/CCX/store/bindingNewSupplier',
    method: 'post',
    data: parameter,
  })
}

// 5.1.7 CCX007-解绑供应商 unbindSupplier
export function unbindSupplier (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjStore/CCX/store/unbindSupplier',
    method: 'post',
    data: parameter,
  })
}

// 获取银行开户地列表
export function getRegionList (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjmerchantsborrower/companyConfigInformationManagement/getRegionList',
    method: 'get',
    params: { ...params }
  })
}

// AMA-001获取放款银行列表
export function getBankInfoList (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjStoreFinance/AMA/getBankInfoList',
    method: 'get',
    params: parameter
  })
}

// AMA-003获取可选开户行支行列表
export function getBankSubbranchList (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjStoreFinance/AMA/getBankSubbranchList',
    method: 'get',
    params: parameter
  })
}

// 5.2.1 CG001-查询优惠列表 getStoreFullGift
export function getStoreFullGift (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjStore/CCX/goods/getStoreFullGift',
    method: 'get',
    params: parameter
  })
}

// 5.2.2 CG002-新增促销 addGift
export function addGift (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjStore/CCX/goods/addGift',
    method: 'post',
    data: parameter
  })
}

// 5.2.3 CG003-修改促销优惠 updateGift
export function updateGift (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjStore/CCX/goods/updateGift',
    method: 'post',
    data: parameter
  })
}

// 5.2.4 CG004-查询商品列表 getGoodsList
export function getGoodsList (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjStore/CCX/goods/getGoodsList',
    method: 'get',
    params: parameter
  })
}

// 5.2.5 CG005-批量上下架商品 batchHandleGoods
export function batchHandleGoods (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjStore/CCX/goods/batchHandleGoods',
    method: 'post',
    data: parameter
  })
}

// 5.2.6 CG006-查询当日订单 getCurrentOrder
export function getCurrentOrder (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjStore/CCX/goods/getCurrentOrder',
    method: 'get',
    params: parameter
  })
}

// 5.2.7 CG007-查询明日订单 getTomorrowOrder
export function getTomorrowOrder (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjStore/CCX/goods/getTomorrowOrder',
    method: 'get',
    params: parameter
  })
}

// 5.2.8 CG008-查询历史订单 getHistoryOrder
export function getHistoryOrder (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjStore/CCX/goods/getHistoryOrder',
    method: 'get',
    params: parameter
  })
}

// 5.2.9 CG009-查询订单详情 getOrderDtl
export function getOrderDtl (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjStore/CCX/goods/getOrderDtl',
    method: 'get',
    params: parameter
  })
}

// 5.2.10 CG010-销售统计按金额 statisticsByMoney
export function statisticsByMoney (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjStore/CCX/goods/statisticsByMoney',
    method: 'get',
    params: parameter
  })
}

// 5.2.11 CG011-销售统计按商品 statisticsByGoods
export function statisticsByGoods (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjStore/CCX/goods/statisticsByGoods',
    method: 'get',
    params: parameter
  })
}

// 5.2.12 CG012-查询商品分类 getGoodsCategoryList
export function getGoodsCategoryList (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjStore/CCX/goods/getGoodsCategoryList',
    method: 'get',
    params: parameter
  })
}

// XM022-stfp文件上传
export function upFileSftp (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    method: 'post',
    url: '/ccxIntegratedService/CCXManage/upFileSftp',
    data: parameter,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}